import React, { useCallback, useMemo } from 'react';
import useStyles from './useStyles';
import { Grid } from '@material-ui/core';
import { CustomizedButton } from '@components/Customized';
import { Enum_Action_Button_Enum } from '@hooks/useUserActionLog';
import { CapaQuotationServiceType } from '@generated/graphql';
import useQueryString from '@hooks/useQueryString';
import { RequestQueryString } from '@routes/NewRequest/types';

interface Props {
  serviceType: CapaQuotationServiceType;
  onCheck: (
    e?: React.BaseSyntheticEvent<object, any, any> | undefined
  ) => Promise<void>;
}

const RequestForQuotationSubmit = ({ serviceType, onCheck }: Props) => {
  const classes = useStyles();
  const { onAddQueryString } = useQueryString<RequestQueryString>();

  const logPreviewId = useMemo(() => {
    if (serviceType === CapaQuotationServiceType.Cnc) {
      return Enum_Action_Button_Enum.Button_RFQ_CNC_Preview;
    }

    if (serviceType === CapaQuotationServiceType.Printing) {
      return Enum_Action_Button_Enum.Button_RFQ_PRINTING_Preview;
    }

    if (serviceType === CapaQuotationServiceType.Inj) {
      return Enum_Action_Button_Enum.Button_RFQ_INJ_Preview;
    }

    if (serviceType === CapaQuotationServiceType.SheetMetal) {
      return Enum_Action_Button_Enum.Button_RFQ_SHEET_METAL_Preview;
    }

    if (serviceType === CapaQuotationServiceType.Casting) {
      return Enum_Action_Button_Enum.Button_RFQ_CASTING_Preview;
    }
  }, [serviceType]);

  const logPrevButtonId = useMemo(() => {
    if (serviceType === CapaQuotationServiceType.Cnc) {
      return Enum_Action_Button_Enum.Button_RFQ_CNC_Prev;
    }

    if (serviceType === CapaQuotationServiceType.Printing) {
      return Enum_Action_Button_Enum.Button_RFQ_PRINTING_Prev;
    }

    if (serviceType === CapaQuotationServiceType.Inj) {
      return Enum_Action_Button_Enum.Button_RFQ_INJ_Prev;
    }

    if (serviceType === CapaQuotationServiceType.SheetMetal) {
      return Enum_Action_Button_Enum.Button_RFQ_SHEET_METAL_Prev;
    }

    if (serviceType === CapaQuotationServiceType.Casting) {
      return Enum_Action_Button_Enum.Button_RFQ_CASTING_Prev;
    }
  }, [serviceType]);

  const goBack = useCallback(() => {
    onAddQueryString({
      detailedServiceType: undefined
    });
  }, [onAddQueryString]);

  return (
    <Grid component="section" container className={classes['rfq-submit']}>
      <Grid item>
        <CustomizedButton
          logId={logPrevButtonId}
          color="default"
          variant="contained"
          size="large"
          onClick={goBack}
        >
          이전 단계
        </CustomizedButton>
      </Grid>
      <Grid item>
        <CustomizedButton
          logId={logPreviewId}
          variant="contained"
          color="primary"
          onClick={onCheck}
          size="large"
        >
          <i className="request-gtm-submitRFQ-btn">작성 완료</i>
        </CustomizedButton>
      </Grid>
    </Grid>
  );
};

export default RequestForQuotationSubmit;
